'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Checkbox = function Checkbox(_ref) {
  var callback = _ref.callback,
      checked = _ref.checked,
      dataAttr = _ref.dataAttr,
      theme = _ref.theme,
      title = _ref.title,
      value = _ref.value;
  return _react2["default"].createElement('label', {
    className: 'nwc--checkbox ' + theme
  }, _react2["default"].createElement('input', {
    type: 'checkbox',
    value: value,
    defaultChecked: checked,
    onClick: function onClick(e) {
      return callback(value, e);
    },
    'data-attr': dataAttr
  }), _react2["default"].createElement('strong', {
    className: 'nwc--checkbox-title font--14'
  }, title));
};

Checkbox.defaultProps = {
  checked: false,
  dataAttr: null,
  theme: ''
};
Checkbox.propTypes = {
  callback: _propTypes.PropTypes.func.isRequired,
  checked: _propTypes.PropTypes.bool,
  dataAttr: _propTypes.PropTypes.string,
  theme: _propTypes.PropTypes.string,
  title: _propTypes.PropTypes.string.isRequired,
  value: _propTypes.PropTypes.string.isRequired
};
exports["default"] = Checkbox;